<template>
  <header class="page-header d-flex justify-content-between align-items-center">
    <h1>{{ getHeaderTitle }}</h1>
    <div class="nav-right">{{ getUserName }}</div>
  </header>
</template>

<style lang="scss">
@import "../assets/styles/main.scss";

.page-header {
  position: fixed;
  width: calc(100% - 200px);
  background: #fff;
  border-bottom: 1px solid $ui-gray-lighter;
  box-shadow: 0px 2px 6px rgba($brand-primary, 0.1);
  padding: 0px 30px;
  height: 80px;
  z-index: 999;
  h1 {
    font-size: 2.5rem;
    color: $text-color-normal;
    font-weight: $font-weight-bold;
    margin-bottom: 0;
    font-family: $font-brand;
  }
  .nav-right {
    font-weight: $font-weight-semibold;
    .user-nav {
      .dropdown-toggle {
        color: $text-color-normal;
        font-weight: $font-weight-normal;
        padding: 0.5rem;
        &:hover {
          text-decoration: none;
          color: $brand-primary;
        }
      }
    }
  }
}
// Responsive Overrides

@media (max-width: 1280px) {
  .page-header {
    width: 100%;

    h1 {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    .nav-right {
      margin: 0 0 0 auto;
    }
  }
}
</style>

<script>
import router from "@/router";
import { getCurrentUser } from "@/services/usersession";

export default {
  name: "PortalPageHeader",
  data() {
    return {
      user: null,
      pageTitle: "Overview"
    };
  },
  computed: {
    getUserName() {
      if (this.user) {
        return this.user.name;
      }
      return "";
    },
    getHeaderTitle() {
      // set page title to current routes name
      /*
      can use either

      router.currentRoute.name

      or

      this.$route.name
      */
     // :( If I take this out the header title is not update - go figure
     console.log(this.$route.name);
     return router.currentRoute.name;
    }
  },
  mounted() {
    // load current user from session
    this.user = getCurrentUser(this.$session);
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      router.push("/login");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PortalPageHeader.vue